import React, { FC, useState } from 'react'
import { UseFormMethods } from 'react-hook-form'
import ControlledHiddenInput from 'transfix-form/components/ControlledHiddenInput'
import { Dispatcher, IDispatcherProps } from 'apps/fleet-planner/pages/loads/Dispatcher'
import { ILoad } from 'apps/fleet-planner/types'

type ILoadDispatcherFields = Pick<ILoad, 'dispatcher' | 'dispatcherId'>

export interface IControlledDispatcherProps {
  name?: string
  defaultValue?: Partial<Pick<ILoad, 'dispatcherId' | 'dispatcher'>>
  DispatcherProps?: Partial<IDispatcherProps>
  control: UseFormMethods['control']
  setValue: UseFormMethods['setValue']
}

/**
 * Helper component for use with React Hook Form
 * @see https://react-hook-form.com/api#Controller
 * @example
 * ```
 * <ControlledDispatcher
 *   control={control}
 *   DispatcherProps={{
 *     large
 *     required
 *   }} />
 * ```
 */
export const ControlledDispatcher: FC<IControlledDispatcherProps> = ({
  name = 'dispatcherId',
  control,
  setValue,
  defaultValue = {},
  DispatcherProps = {},
}) => {
  const { error = '', large = true, selectedMotorCarrierId, shown } = DispatcherProps || {}
  const { dispatcherId: defaultDispatcherId } = defaultValue || {}
  const [dispatcher, setDispatcher] = useState<ILoadDispatcherFields>({ ...defaultValue })

  const handleChange = (change: ILoadDispatcherFields) => {
    setValue(name, change.dispatcherId, { shouldValidate: true })
    setDispatcher(change)
  }

  return (
    <>
      <Dispatcher
        value={dispatcher}
        onChange={handleChange}
        error={error}
        large={large}
        shown={shown}
        selectedMotorCarrierId={selectedMotorCarrierId}
      />
      <ControlledHiddenInput name={name} defaultValue={defaultDispatcherId} control={control} />
    </>
  )
}
